import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import { InputSuffix, TextBox, TextBoxChangeEvent, TextBoxProps } from "@progress/kendo-react-inputs"
import { Icon } from "components/Icon/Icon";
import styles from './SearchInput.module.scss'
import { useCallback, useEffect, useState } from "react";
import _ from "lodash";

type SearchInputProps = {
    onValueChange: (value: string) => void,
    delay?: number
} & TextBoxProps

const SearchInput = ({onValueChange, value, delay = 300,...props} : SearchInputProps) =>
{
    const [inputValue, setInputValue] = useState<string>("");

    const debouncedChangeHandler = useCallback(
        _.debounce((value: string) => onValueChange(value), delay),
        [onValueChange, delay]
    );

    useEffect(()=>{
        setInputValue(value?.toString() ?? '');
    }, [value])
    
    const handleChange = (e: TextBoxChangeEvent) => {
        setInputValue(e.value?.toString() ?? '');
        debouncedChangeHandler(e.value?.toString() ?? '');
    };
    return (<TextBox
        suffix={()=> <InputSuffix><Icon  icon={faMagnifyingGlass}/> </InputSuffix>}
        className={styles.input}
        placeholder='Filter'
        onChange={handleChange}
        {...props}
        value={inputValue}
    />)
}

export default SearchInput;